module.exports = __webpack_public_path__ + "img/culture02.1197dcaf.jpg";